import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { closeGroupSelectorDialog } from './actions';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { selectDeviceTree } from 'console/redux/devices/tree/selectors';
import { moveDeviceInTree } from 'console/left-menu/set-device-tree-group/action';
import { getGroupsNameWithPath, } from 'console/left-menu/set-device-tree-group/utils';
import * as lodash from 'lodash';
import { getOptions } from './utils/group-selector-utils';
const GroupSelectorDialogImpl = memo(function RenameDialogImpl(props) {
    const device_tree = useAppSelector(selectDeviceTree);
    const onSelectGroup = useAction(moveDeviceInTree);
    const { dialog_state, onClose } = props;
    const { open, node } = dialog_state;
    if (!node || !('children' in node))
        return _jsx(_Fragment, {});
    const groups = getGroupsNameWithPath(device_tree);
    const node_path = groups.find((el) => el.id === node.id);
    if (!node_path)
        return _jsx(_Fragment, {});
    const [new_group_key, setGroupKey] = useState(null);
    const dropdownOptions = useMemo(() => {
        return getOptions(groups, node_path.path);
    }, [groups, node_path]);
    const [new_path, setNewPath] = useState({
        old_path: [],
        new_path: [],
    });
    const _onConfirm = useCallback(() => {
        onSelectGroup(new_path);
        onClose();
    }, [onSelectGroup, new_path, onClose]);
    const handleChange = useCallback((new_value) => {
        setGroupKey(new_value);
        const new_group = groups[parseInt(new_value.id, 10)];
        //Если нет группы, значит выкидываем в корень
        const new_path = new_group != null ? new_group.path : [];
        //Отправим наверх, что выбрали
        if (!lodash.isEqual(node_path.path, new_path)) {
            setNewPath({ old_path: node_path.path, new_path });
        }
    }, [setGroupKey, groups, setNewPath]);
    const getOptionLabel = useCallback((option) => option.name, []);
    return (_jsx(MessageBox, { open: open, onClose: onClose, maxWidth: "xs", title: "\u0418\u043C\u044F \u0433\u0440\u0443\u043F\u043F\u044B", footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: onClose, color: "primary", children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { onClick: _onConfirm, color: "primary", children: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C" })] }), children: _jsx(Box, { width: 240, children: _jsx(Autocomplete, { fullWidth: true, options: dropdownOptions, value: new_group_key, onChange: (event, newValue) => {
                    if (newValue)
                        handleChange(newValue);
                }, getOptionLabel: getOptionLabel, autoHighlight: true, autoSelect: true, noOptionsText: "\u041D\u0435 \u043D\u0430\u0448\u043B\u043E\u0441\u044C :(", renderInput: (params) => _jsx(TextField, { ...params }) }) }) }));
});
const GroupSelectorDialogKey = memo(function RenameDialogKey(props) {
    return _jsx(GroupSelectorDialogImpl, { ...props }, props.dialog_state.randomKey);
});
export const GroupSelectorDialog = connect(createStructuredSelector({
    dialog_state: (state) => state.group_selector_dialog,
}), { onClose: closeGroupSelectorDialog })(GroupSelectorDialogKey);
